module.exports = __webpack_public_path__ + "static/media/chevron_blue.c42f1c59.svg";